import React from 'react'
import Title from './Title'
import Text from './Text'
import { Flex } from 'antd'
import Subtitle from './Subtitle'

const cssMaterial = {
  fontSize: '25px',
  fontWeight: 'bold',
  borderWidth: '2px',
  borderColor: 'rgb(240, 240, 240)',
  borderStyle: 'solid',
  borderRadius: '25px',
  width: '307px',
  padding: '0.5em',
  textAlign: 'center'
}

export default function MedicalDevices () {
  return (
    <>
      <Title text={'Les examens disponibles'} />
      <Text
        text={`Le cabinet médical dispose de dimensions confortables et est connecté à un réseau majeur de médecins,
          la Box Médicale est équipée de l'ensemble des instruments de mesure nécessaires au diagnostic médical et à un examen clinique.`}
      />
      <Subtitle text={'Une téléconsultation augmentée'} />
      <Text text={'La borne est équipée de 6 dispositifs connectés :'}/>
      <Flex align='space-around' gap={'20px'} style={{ padding: '0 2em' }}>
        <div style={cssMaterial}>Thermomètre</div>
        <div style={cssMaterial}>Tensiomètre</div>
        <div style={cssMaterial}>Oxymètre</div>
        <div style={cssMaterial}>Dermatoscope</div>
        <div style={cssMaterial}>Otoscope</div>
        <div style={cssMaterial}>Stéthoscope</div>
      </Flex>
    </>
  )
}
